export class GeneLoc {
  fmax: number;
  fmin: number;
}
